/** Apply document-level Persian RTL only on auth / panel layouts. */
export function usePersianLayout() {
  useHead({
    htmlAttrs: {
      lang: 'fa',
      dir: 'rtl',
    },
  })
}
